<div class="reading-room-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  <div class="heading-wrapper">
    <h4>{{ 'pages.tooltips.editTile' | translate }}</h4>
    <div class="actions">
      <button class="primary" (click)="submit()">{{ 'pages.tooltips.save' | translate }}</button>
      <button class="secondary" (click)="back()">{{ 'pages.tooltips.cancel' | translate }}</button>
    </div>
  </div>
  @if (isLoading) {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="true" />
    </div>
  }
  @if (!isLoading) {
    <form [formGroup]="form" [ngClass]="{ hidden: isSubmitting }">
      <div class="form-group code-group">
        <p class="form-label lna">{{ 'pages.tooltips.code' | translate }}</p>
        <p class="form-value">{{ tooltip?.code }}</p>
      </div>
      <div class="lna-row full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="text">
            {{ 'pages.tooltips.labelText' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip text="tooltipText"></app-tooltip>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="text"
            [ngClass]="{ invalid: shouldRenderError('text') }"
            type="text"
            formControlName="text"
            name="text"
            required
            maxlength="{{ maxLengthText }}"></textarea>
          <p class="length" [ngClass]="{ invalid: text?.value.length > maxLengthText }">{{ text?.value.length }}/{{ maxLengthText }}</p>
        </div>
        @if (getErrorMessage('text', form); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="textEn">
            {{ 'pages.tooltips.labelTextEn' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip text="tooltipTextEn"></app-tooltip>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="textEn"
            [ngClass]="{ invalid: shouldRenderError('textEn') }"
            type="textEn"
            formControlName="textEn"
            name="textEn"
            required
            maxlength="{{ maxLengthTextEn }}"></textarea>
          <p class="length" [ngClass]="{ invalid: textEn?.value.length > maxLengthTextEn }">
            {{ textEn?.value.length }}/{{ maxLengthTextEn }}
          </p>
        </div>
        @if (getErrorMessage('textEn', form); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="description">
            {{ 'pages.tooltips.labelDescription' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip text="tooltipDescription"></app-tooltip>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="description"
            [ngClass]="{ invalid: shouldRenderError('description') }"
            type="text"
            formControlName="description"
            name="description"
            required
            maxlength="{{ maxLengthDescription }}"></textarea>
          <p class="length" [ngClass]="{ invalid: description?.value.length > maxLengthDescription }">
            {{ description?.value.length }}/{{ maxLengthDescription }}
          </p>
        </div>
        @if (getErrorMessage('description', form); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row full-width">
        <div class="label-wrapper">
          <p class="form-label lna" for="description">
            {{ 'pages.tooltips.labelImage' | translate }}
            <span class="required-field">*</span>
          </p>
          <app-tooltip text="tooltipImage"></app-tooltip>
        </div>
        @if (!isLoading && !imageUrl) {
          <app-file-upload
            [isEditMode]="true"
            [existingFiles]="[]"
            [type]="tooltipFileType"
            [associatedEntityId]="tooltip?.id || ''"
            [showDescription]="false"
            [isSubmitting]="isSubmittingFiles"
            (uploading)="handleFileRequests($event)" />
        } @else if (imageUrl) {
          <div class="image-wrapper">
            <img class="location-image" [src]="imageUrl" alt="Tooltip Image" />
          </div>
          <button class="link link-btn" (click)="isOpenConfirmDeleteImage = true">
            <img src="assets/images/delete-icon.svg" alt="delete" />
            {{ 'pages.tooltips.deleteImage' | translate }}
          </button>
        }
      </div>
    </form>
  }
</div>
<app-confirm-modal
  [isOpen]="isOpenConfirmBack"
  (confirm)="back(true)"
  (cancel)="isOpenConfirmBack = false"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
<app-confirm-modal
  [isOpen]="isOpenConfirmDeleteImage"
  (confirm)="deleteImage()"
  (cancel)="isOpenConfirmDeleteImage = false"
  title="deleteTooltipImage"
  confirmText="delete"
  denyText="cancel" />
